import { marketingRouteMeta } from '#marketing/lib/marketing-route-meta.js';
import { MarketingGuidesPage } from '#marketing/components/MarketingGuidesPage.jsx';

/** @param {{ matches: Array<{ id?: string, pathname?: string, loaderData?: unknown }> }} args */
export function meta({ matches }) {
  return marketingRouteMeta({ matches, page: 'guides', pagePath: '/guides' });
}

export default function Guides() {
  return <MarketingGuidesPage />;
}
